import format from 'number-format.js'

export default {
  computed: {
    pf_format() {
      const { thSep, dSep } = this.pf_getSeparators()
      return '#' + thSep + '###' + dSep + '###'
    }
  },

  methods: {
    pf_getSeparators() {
      let thSep = this.settings.thousand_separator
      thSep = thSep === 'space' ? ' ' : thSep
      return {
        thSep,
        dSep: this.settings.decimal_separator
      }
    },

    pf_convertNumberToPrice(nr) {
      return format(this.pf_format, nr)
    }
  }
}
